import { Component } from '@angular/core';
import { ProductImageZoomViewComponent } from "@spartacus/product/image-zoom/components";
import { ICON_TYPE } from '@spartacus/storefront';


@Component({
  selector: 'cx-product-image-zoom-view',
  templateUrl: './custom-product-image-zoom-view.component.html',
  styleUrls: ['custom-product-image-zoom-view.component.scss'],
  standalone: false
})
export class CustomProductImageZoomViewComponent extends ProductImageZoomViewComponent {
  iconTypes = ICON_TYPE;
}
